import { createSelector } from 'reselect';

const getFilters = state => state && state.auth ? state.auth.config.filters : null;

export const getDefaultCostCenters = createSelector([getFilters], filters => {
  let countries = null;
  if (
    filters &&
    filters.length &&
    filters.find(item => item.title === 'Country')
  ) {
    countries = filters.find(item => item.title === 'Country').children;
  }
  return countries;
});

const getRoles = createSelector([getFilters], filters => {
  let roles = null;
  if (
    filters &&
    filters.length &&
    filters.find(item => item.title === 'Role Filter')
  ) {
    roles = filters.find(item => item.title === 'Role Filter').children;
  }
  return roles;
});
const getSelectedRole = state => state && state.auth && state.auth.role ? state.auth.role : null;

export const getFormatedRoles = createSelector([getRoles], roles => {
  let formatedRoles = null;
  if (roles && roles.length) {
    formatedRoles = roles.map(item => ({
      value: item.id,
      label: item.title,
      country: item.metadata.countryCode
    }));
  }
  return formatedRoles;
});

export const getCurrentRole = createSelector(
  [getSelectedRole, getFormatedRoles],
  (role, roles) => {
    if (role || (roles && roles.length)) {
      // Pick values from session storage if available
      let curRole = roles[0]; // default
      const roleId = sessionStorage.getItem('roleId');
      if (roleId) {
        curRole = roles.find(x => x.value === roleId);
      }
      return curRole;
    }
    return null;
  }
);



// WEBPACK FOOTER //
// ./src/components/common/Profile/selector.js